/**
 * PMV BARRA - STANDALONE WEB COMPONENT
 * @description Encapsulated institutional bar for external systems
 */
import styleText from '../styles/components/_barra-standalone.scss';

class PmvBarraElement extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this._bindEvents();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        ${styleText}
      </style>
      <div class="barra-pmv-ds">
          <div class="barra-pmv-ds__inner">
              <div class="barra-pmv-ds__container-topo">
                  
                  <!-- Lado Esquerdo -->
                  <div class="menu-lado menu-lado--esquerdo">
                      <ul>
                          <li><a href="https://www.vitoria.es.gov.br/secretarias.php">Secretarias</a></li>
                          <li><a href="https://portalservicos.vitoria.es.gov.br/">Serviços</a></li>
                          <li><a href="https://transparencia.vitoria.es.gov.br/">Transparência</a></li>
                      </ul>
                  </div>

                  <!-- Centro: Logo -->
                  <div class="logo">
                      <a href="https://www.vitoria.es.gov.br" title="Vai para o Portal">
                          <img src="https://assets.vitoria.es.gov.br/pmv/images/brasao-index-escuro.svg" alt="Prefeitura Municipal de Vitória" />
                      </a>
                  </div>

                  <!-- Lado Direito -->
                  <div class="menu-lado menu-lado--direito">
                      <ul>
                          <li><a href="https://www.vitoria.es.gov.br/legislacao.php">Legislação</a></li>
                          <li><a href="https://www.vitoria.es.gov.br/noticias.php">Notícias</a></li>
                          <li><a href="https://observavix.vitoria.es.gov.br/">ObservaVix</a></li>
                      </ul>
                  </div>

              </div>
          </div>
      </div>
    `;
  }

  _bindEvents() {
    window.addEventListener('scroll', () => {
      const sc = window.scrollY || window.pageYOffset;
      const barraElement = this.shadowRoot.querySelector('.barra-pmv-ds__inner');
      if (barraElement) {
        if (sc > 70) {
          barraElement.classList.add('barra-pmv-ds__inner--small');
        } else {
          barraElement.classList.remove('barra-pmv-ds__inner--small');
        }
      }
    });
  }
}

if (!customElements.get('pmv-barra')) {
  customElements.define('pmv-barra', PmvBarraElement);
}
